import * as React from 'react';
import { mxStrings } from 'utils/JobCollabStrings';
import './jobDetailsSummarySection.scss';

interface JobDetailsSummarySectionProp {
    className?: string;
    employees?: number;
    salaryGrade?: string;
    yearsExperience?: CompfactorValue;
}

interface BodyData {
    name: string;
    data?: CompfactorValue;
}

class JobDetailsSummarySection extends React.Component<JobDetailsSummarySectionProp, {}> {

    render(): React.ReactNode {
        const { className, employees, salaryGrade, yearsExperience } = this.props;
        return <div className={`job-details-summary-container ${className ? className : ''}`}>
            { this._renderSummary(employees, salaryGrade, yearsExperience) }
        </div>;
    }

    private _renderSummaryBody(name: string, data: string|number, index: number): React.ReactNode {
        if (typeof data === 'undefined' || data === null) {
            data = mxStrings.unspecifiedValue;
        }
        return <div className="header-body-details" key={index}>
            <span className="job-details-summary-header pxl-small">
                { name }
            </span>
            <div className="summary-body-data" key={index}>
                <span>{ data }</span>
            </div>
        </div>;
    }

    private _renderSummary(employees?: number, salaryGrade?: string, yearsExperience?: CompfactorValue): React.ReactNode {
        const bodyData: BodyData[] = [
            { name: mxStrings.jobDetailsSummaryEmployee,   data: employees },
            { name: mxStrings.jobDetailsSummaryGrade,      data: salaryGrade },
            { name: mxStrings.jobDetailsSummaryExperience, data: yearsExperience }
        ];

        return <div className="summary-body">
            { bodyData.map((data: BodyData, index: number) => {
                return this._renderSummaryBody(data.name, data.data as string|number, index);
            }) }
        </div>;
    }
}

export { JobDetailsSummarySection };
export default JobDetailsSummarySection;